import React, { useCallback } from 'react';
export function BaseButton(props) {
    const { as, onClick, defaultOnClick, children, buttonRef, ...passthroughProps } = props;
    const handleOnClick = useCallback((event) => {
        if (onClick) {
            const clickShouldContinue = onClick(event);
            if ((typeof clickShouldContinue === 'boolean' &&
                clickShouldContinue === false) ||
                event?.defaultPrevented)
                return;
        }
        defaultOnClick?.(event);
    }, [defaultOnClick, onClick]);
    const Component = as || 'button';
    return (React.createElement(Component, { ref: buttonRef, onClick: handleOnClick, ...passthroughProps }, children));
}
